// OXXRING_GA4_ATTRIBUTION_CACHE_SYNC_20261019
(function () {
  'use strict';

  var MEASUREMENT_ID = 'G-LBH2238YVV';
  var queued = [];
  var ga4Ready = false;
  var identifiersEnriched = false;
  var ga4Frame = null;
  var ga4FrameGtag = null;
  var ga4FrameReady = false;
  var ga4FrameLoading = false;
  window.oxxGa4CustomTagStatus = 'CONSENT_REQUIRED';
  var attributionKey = 'oxxring:consented-attribution:v2';
  var persistentAttributionKey = 'oxxring:consented-attribution-persistent:v2';
  var ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var TOUCH_REFRESH_WINDOW_MS = 30 * 60 * 1000;
  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic'];
  var CLICK_ID_FIELDS = ['gclid', 'gbraid', 'wbraid', 'dclid', 'fbclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id', 'epik', 'sccid', 'sc_cid', 'rdt_cid', 'qclid', 'yclid', 'bd_vid', 'tblci', 'dicbo', 'srsltid', 'irclickid', 'cjevent', 'awc'];
  var ATTRIBUTION_EVENT_FIELDS = ['attribution_scope', 'first_touch_source', 'first_touch_medium', 'first_touch_campaign', 'first_touch_landing_path', 'first_touch_referrer_host', 'first_touch_click_id_type', 'last_touch_source', 'last_touch_medium', 'last_touch_campaign', 'last_touch_landing_path', 'last_touch_referrer_host', 'last_touch_click_id_type', 'last_utm_source', 'last_utm_medium', 'last_utm_campaign', 'attribution_click_id_present'];
  var rfqEventsSeen = Object.create(null);

  function marketingAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(cp && typeof cp.marketingAllowed === 'function'
      && cp.marketingAllowed() && navigator.globalPrivacyControl !== true);
  }

  function attributionValue(value) {
    var text = String(value || '').trim();
    text = Array.prototype.filter.call(text, function (ch) {
      var code = ch.charCodeAt(0);
      return code >= 32 && code !== 127;
    }).join('');
    return text.indexOf('@') >= 0 ? '' : text.slice(0, 200);
  }

  function queryValue(params, key) {
    var direct = params.get(key);
    if (direct) return direct;
    var found = '';
    params.forEach(function (value, name) {
      if (!found && String(name).toLowerCase() === String(key).toLowerCase()) found = value;
    });
    return found;
  }

  function externalReferrerHost() {
    try {
      if (!document.referrer) return '';
      var url = new URL(document.referrer);
      var host = url.hostname.toLowerCase().replace(/\.$/, '');
      var currentHost = window.location.hostname.toLowerCase().replace(/\.$/, '');
      // Internal account/checkout links must never replace a genuine acquisition touch.
      if (host === currentHost || host === 'oxxring.com' ||
          host.slice(-12) === '.oxxring.com' || host === 'eirqeb-wd.myshopify.com') return '';
      return host.indexOf('www.') === 0 ? host.slice(4, 124) : host.slice(0, 120);
    } catch (error) { return ''; }
  }

  function clickChannel(key) {
    var map = {
      gclid: ['google', 'cpc'], gbraid: ['google', 'cpc'], wbraid: ['google', 'cpc'],
      dclid: ['google', 'display'], fbclid: ['facebook', 'paid_social'],
      msclkid: ['bing', 'cpc'], ttclid: ['tiktok', 'paid_social'],
      twclid: ['x', 'paid_social'], li_fat_id: ['linkedin', 'paid_social'],
      epik: ['pinterest', 'paid_social'], sccid: ['snapchat', 'paid_social'],
      sc_cid: ['snapchat', 'paid_social'], rdt_cid: ['reddit', 'paid_social'],
      qclid: ['quora', 'paid_social'], yclid: ['yahoo', 'paid_search'],
      bd_vid: ['baidu', 'paid_search'], tblci: ['taboola', 'paid'],
      dicbo: ['outbrain', 'paid'], srsltid: ['google', 'organic'],
      irclickid: ['impact', 'affiliate'], cjevent: ['commission_junction', 'affiliate'],
      awc: ['affiliate', 'affiliate']
    };
    return map[key] || ['', ''];
  }

  function isSearchReferrer(host) {
    return host.indexOf('google.') >= 0 || host === 'bing.com' || host.indexOf('.bing.com') >= 0 ||
      host === 'search.yahoo.com' || host.indexOf('duckduckgo.com') >= 0 ||
      host.indexOf('baidu.com') >= 0 || host.indexOf('yandex.') >= 0 ||
      host.indexOf('ecosia.org') >= 0 || host.indexOf('search.brave.com') >= 0;
  }

  function currentTouch(params) {
    var utm = {};
    UTM_FIELDS.forEach(function (key) {
      var value = attributionValue(queryValue(params, key));
      if (value) utm[key] = value;
    });
    var clickIdType = '', clickIdValue = '';
    if (marketingAllowed()) {
      CLICK_ID_FIELDS.some(function (key) {
        var value = attributionValue(queryValue(params, key));
        if (value && /^[A-Za-z0-9._~-]{4,200}$/.test(value)) {
          clickIdType = key;
          clickIdValue = value;
          return true;
        }
        return false;
      });
    }
    var referrerHost = externalReferrerHost();
    var channel = clickIdType ? clickChannel(clickIdType) : ['', ''];
    var source = utm.utm_source || channel[0] || '';
    var medium = utm.utm_medium || channel[1] || '';
    var campaign = utm.utm_campaign || attributionValue(queryValue(params, 'gad_campaignid')) || '';
    var googleCampaignHint = Boolean(queryValue(params, 'gad_source') || queryValue(params, 'gad_campaignid') || queryValue(params, 'gclsrc'));
    if (!source && googleCampaignHint) source = 'google';
    if (!medium && googleCampaignHint) medium = 'cpc';
    if (!source && referrerHost) {
      source = referrerHost;
      medium = isSearchReferrer(referrerHost) ? 'organic' : 'referral';
    }
    if (!source) source = 'direct';
    if (!medium) medium = source === 'direct' ? 'none' : 'unknown';
    var hasUtm = UTM_FIELDS.some(function (key) { return Boolean(utm[key]); });
    var isNonDirect = hasUtm || Boolean(clickIdType) || Boolean(referrerHost) || googleCampaignHint;
    var signature = JSON.stringify({
      utm: utm, click_id_type: clickIdType, click_id_value: clickIdValue,
      referrer_host: referrerHost, landing_path: window.location.pathname || '/'
    });
    return {
      utm: utm, source: source, medium: medium, campaign: campaign,
      click_id_type: clickIdType, click_id_value: clickIdValue,
      referrer_host: referrerHost, landing_path: window.location.pathname || '/',
      is_non_direct: isNonDirect, signature: signature
    };
  }

  function readAttributionContext() {
    var context = null;
    try {
      var raw = window.localStorage.getItem(persistentAttributionKey);
      if (raw) context = JSON.parse(raw);
    } catch (error) {}
    if (!context) {
      try {
        var sessionRaw = window.sessionStorage.getItem(attributionKey);
        if (sessionRaw) context = JSON.parse(sessionRaw);
      } catch (error) {}
    }
    if (context && context.expires_at_ms && Number(context.expires_at_ms) <= Date.now()) context = null;
    if (context && context.version !== 2) context = null;
    return context;
  }

  function saveAttributionContext(context) {
    var serialized = JSON.stringify(context);
    try { window.localStorage.setItem(persistentAttributionKey, serialized); } catch (error) {}
    try { window.sessionStorage.setItem(attributionKey, serialized); } catch (error) {}
  }

  function clearAttributionContext() {
    try { window.localStorage.removeItem(persistentAttributionKey); } catch (error) {}
    try { window.sessionStorage.removeItem(attributionKey); } catch (error) {}
  }

  function applyTouch(context, prefix, touch, timestamp) {
    context[prefix + '_source'] = touch.source;
    context[prefix + '_medium'] = touch.medium;
    context[prefix + '_campaign'] = touch.campaign || '';
    context[prefix + '_landing_path'] = touch.landing_path;
    context[prefix + '_referrer_host'] = touch.referrer_host || '';
    context[prefix + '_at'] = timestamp;
    context[prefix + '_click_id_type'] = touch.click_id_type || '';
    context[prefix + '_click_id_value'] = touch.click_id_value || '';
    if (prefix === 'last_touch') {
      UTM_FIELDS.forEach(function (key) { context['last_' + key] = touch.utm[key] || ''; });
    }
  }

  function attributionContext() {
    try {
      // Consent can still be initializing on first paint. Preserve previously
      // consented attribution unless an explicit consent update revokes it.
      if (!trackingAllowed()) return null;
      var now = Date.now();
      var timestamp = new Date(now).toISOString();
      var params = new URLSearchParams(window.location.search || '');
      var touch = currentTouch(params);
      var context = readAttributionContext();
      if (!context) {
        context = {
          version: 2,
          first_observed_landing_path: touch.landing_path,
          first_observed_at: timestamp,
          attribution_scope: 'CONSENTED_FIRST_PARTY_90D',
          expires_at_ms: now + ATTRIBUTION_TTL_MS,
          attribution_expires_at: new Date(now + ATTRIBUTION_TTL_MS).toISOString()
        };
        applyTouch(context, 'first_touch', touch, timestamp);
        applyTouch(context, 'last_touch', touch, timestamp);
        context.last_paid_click_id_type = touch.click_id_type || '';
        context.last_paid_click_id_value = touch.click_id_value || '';
        context.last_paid_click_at = touch.click_id_type ? timestamp : '';
        context.last_touch_signature = touch.signature;
        UTM_FIELDS.forEach(function (key) { context[key] = touch.utm[key] || ''; });
      } else {
        if (!context.first_touch_source) applyTouch(context, 'first_touch', touch, context.first_observed_at || timestamp);
        if (!context.last_touch_source) applyTouch(context, 'last_touch', touch, timestamp);
        var lastAt = Date.parse(context.last_touch_at || '') || 0;
        var refreshLastTouch = touch.is_non_direct && (context.last_touch_signature !== touch.signature || now - lastAt > TOUCH_REFRESH_WINDOW_MS);
        if (refreshLastTouch) {
          applyTouch(context, 'last_touch', touch, timestamp);
          context.last_touch_signature = touch.signature;
          // Refresh the 90-day retention window when a new non-direct touch is observed.
          context.expires_at_ms = now + ATTRIBUTION_TTL_MS;
        }
        UTM_FIELDS.forEach(function (key) {
          if (!context[key] && touch.utm[key]) context[key] = touch.utm[key];
        });
        if (!context.first_touch_click_id_type && touch.click_id_type &&
            context.first_observed_landing_path === touch.landing_path) {
          var firstTouchClickChannel = clickChannel(touch.click_id_type);
          if (context.first_touch_source === firstTouchClickChannel[0] && context.first_touch_medium === firstTouchClickChannel[1]) {
            context.first_touch_click_id_type = touch.click_id_type;
            context.first_touch_click_id_value = touch.click_id_value;
          }
        }
      }
      if (marketingAllowed()) {
        CLICK_ID_FIELDS.forEach(function (key) {
          var value = attributionValue(queryValue(params, key));
          if (value && /^[A-Za-z0-9._~-]{4,200}$/.test(value)) context[key] = value;
        });
        if (touch.click_id_type && touch.click_id_value) {
          context.last_touch_click_id_type = touch.click_id_type;
          context.last_touch_click_id_value = touch.click_id_value;
          context.last_paid_click_id_type = touch.click_id_type;
          context.last_paid_click_id_value = touch.click_id_value;
          context.last_paid_click_at = timestamp;
        } else {
          context.last_touch_click_id_type = context.last_touch_click_id_type || '';
          context.last_touch_click_id_value = context.last_touch_click_id_value || '';
        }
      } else {
        CLICK_ID_FIELDS.forEach(function (key) { delete context[key]; });
        context.first_touch_click_id_type = '';
        context.first_touch_click_id_value = '';
        context.last_touch_click_id_type = '';
        context.last_touch_click_id_value = '';
        context.last_paid_click_id_type = '';
        context.last_paid_click_id_value = '';
        context.last_paid_click_at = '';
      }
      context.source = context.last_touch_source || context.first_touch_source || 'direct';
      context.medium = context.last_touch_medium || context.first_touch_medium || 'none';
      context.campaign = context.last_touch_campaign || context.first_touch_campaign || '';
      context.referrer_host = context.last_touch_referrer_host || context.first_touch_referrer_host || '';
      context.attribution_click_id_type = context.last_paid_click_id_type || context.last_touch_click_id_type || '';
      context.attribution_click_id_present = Boolean(context.first_touch_click_id_value || context.last_paid_click_id_value);
      context.attribution_scope = 'CONSENTED_FIRST_PARTY_90D';
      context.attribution_expires_at = new Date(Number(context.expires_at_ms) || (now + ATTRIBUTION_TTL_MS)).toISOString();
      saveAttributionContext(context);
      return JSON.parse(JSON.stringify(context));
    } catch (error) { return null; }
  }

  function debugModeEnabled() {
    try { return new URLSearchParams(window.location.search || '').has('gtm_debug'); }
    catch (error) { return false; }
  }

  function ga4ConsentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var analytics = trackingAllowed();
    var gpc = navigator.globalPrivacyControl === true;
    var marketing = marketingAllowed() && !gpc;
    var saleAllowed = true;
    try {
      saleAllowed = !cp || typeof cp.saleOfDataAllowed !== 'function' || cp.saleOfDataAllowed();
    } catch (error) { saleAllowed = false; }
    var personal = marketing && saleAllowed && !gpc;
    return {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: personal ? 'granted' : 'denied',
      ad_personalization: personal ? 'granted' : 'denied'
    };
  }

  function updateGa4FrameConsent() {
    if (!ga4FrameReady || typeof ga4FrameGtag !== 'function') return;
    try { ga4FrameGtag('consent', 'update', ga4ConsentState()); } catch (error) {}
  }

  function disposeGa4Frame() {
    try {
      if (typeof ga4FrameGtag === 'function') {
        ga4FrameGtag('consent', 'update', {
          analytics_storage: 'denied', ad_storage: 'denied',
          ad_user_data: 'denied', ad_personalization: 'denied'
        });
      }
    } catch (error) {}
    try {
      if (ga4Frame && ga4Frame.parentNode) ga4Frame.parentNode.removeChild(ga4Frame);
    } catch (error) {}
    ga4Frame = null;
    ga4FrameGtag = null;
    ga4FrameReady = false;
    ga4FrameLoading = false;
    ga4Ready = false;
    identifiersEnriched = false;
    window.oxxGa4CustomTagStatus = trackingAllowed() ? 'LOADING' : 'CONSENT_REQUIRED';
  }

  function ensureGa4Frame() {
    if (!trackingAllowed()) {
      if (ga4Frame || ga4FrameLoading || ga4FrameReady) disposeGa4Frame();
      window.oxxGa4CustomTagStatus = 'CONSENT_REQUIRED';
      return;
    }
    // Avoid initializing a second instance of the same measurement ID while the primary storefront tag is still loading.
    var parentTagStatus = window.oxxGa4TrackingStatus;
    if (parentTagStatus && parentTagStatus !== 'READY' && parentTagStatus !== 'LOAD_ERROR') {
      window.oxxGa4CustomTagStatus = 'WAITING_FOR_PARENT_TAG';
      return;
    }
    if (ga4FrameReady && ga4Ready && typeof ga4FrameGtag === 'function') {
      updateGa4FrameConsent();
      flushQueuedEvents();
      return;
    }
    if (ga4FrameLoading) return;

    ga4FrameLoading = true;
    ga4FrameReady = false;
    ga4Ready = false;
    window.oxxGa4CustomTagStatus = 'LOADING';

    var frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.setAttribute('title', '');
    frame.style.cssText = 'display:none!important;width:0;height:0;border:0;';
    ga4Frame = frame;

    try {
      (document.body || document.documentElement).appendChild(frame);
      var frameWindow = frame.contentWindow;
      var frameDocument = frame.contentDocument;
      if (!frameWindow || !frameDocument) throw new Error('GA4 isolated frame unavailable');

      frameDocument.open();
      frameDocument.write('<!doctype html><html><head></head><body></body></html>');
      frameDocument.close();

      // Define gtag in the iframe's own realm; cross-realm Arguments objects can be ignored by gtag.js.
      frameWindow.eval("window.oxxGa4DataLayer = window.oxxGa4DataLayer || []; window.gtag = function () { window.oxxGa4DataLayer.push(arguments); };");
      var frameLayer = frameWindow.oxxGa4DataLayer;
      frameWindow.gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500
      });
      frameWindow.gtag('js', new Date());
      var config = { send_page_view: false };
      if (debugModeEnabled()) config.debug_mode = true;
      frameWindow.gtag('config', MEASUREMENT_ID, config);

      var script = frameDocument.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(MEASUREMENT_ID) + '&l=oxxGa4DataLayer';
      script.onload = function () {
        if (ga4Frame !== frame || !trackingAllowed()) {
          if (ga4Frame === frame) disposeGa4Frame();
          return;
        }
        ga4FrameGtag = frameWindow.gtag;
        ga4FrameLoading = false;
        ga4FrameReady = true;
        ga4Ready = true;
        window.oxxGa4CustomTagStatus = 'READY';
        updateGa4FrameConsent();
        if (!identifiersEnriched) {
          identifiersEnriched = true;
          enrichGa4Identifiers();
        }
        flushQueuedEvents();
      };
      script.onerror = function () {
        if (ga4Frame !== frame) return;
        ga4FrameGtag = null;
        ga4FrameLoading = false;
        ga4FrameReady = false;
        ga4Ready = false;
        window.oxxGa4CustomTagStatus = 'LOAD_ERROR';
        try { if (frame.parentNode) frame.parentNode.removeChild(frame); } catch (error) {}
        ga4Frame = null;
      };
      frameDocument.head.appendChild(script);
    } catch (error) {
      ga4FrameGtag = null;
      ga4FrameLoading = false;
      ga4FrameReady = false;
      ga4Ready = false;
      window.oxxGa4CustomTagStatus = 'LOAD_ERROR';
      try { if (frame.parentNode) frame.parentNode.removeChild(frame); } catch (ignore) {}
      if (ga4Frame === frame) ga4Frame = null;
    }
  }

  function sendGa4Event(eventName, params) {
    if (!trackingAllowed()) {
      queued.length = 0;
      return;
    }
    var payload = Object.assign({}, params || {});
    // Never fan out OXX custom events to connected Google Ads destinations.
    payload.send_to = MEASUREMENT_ID;
    payload.page_location = window.location.href;
    payload.page_referrer = externalReferrerHost() ? (document.referrer || '') : '';
    if (!ga4FrameReady || !ga4Ready || typeof ga4FrameGtag !== 'function') {
      queued.push({ name: eventName, params: payload });
      if (queued.length > 40) queued.shift();
      ensureGa4Frame();
      return;
    }
    try {
      updateGa4FrameConsent();
      ga4FrameGtag('event', eventName, payload);
    } catch (error) {
      queued.push({ name: eventName, params: payload });
      if (queued.length > 40) queued.shift();
      ga4FrameReady = false;
      ga4Ready = false;
      ensureGa4Frame();
    }
  }

  function enrichGa4Identifiers() {
    if (!ga4Ready || !trackingAllowed() || typeof ga4FrameGtag !== 'function') return;
    ['client_id', 'session_id'].forEach(function (key) {
      try {
        ga4FrameGtag('get', MEASUREMENT_ID, key, function (value) {
          if (!value || !trackingAllowed()) return;
          var context = attributionContext();
          if (!context) return;
          var cleanValue = attributionValue(value);
          if (!cleanValue) return;
          context['ga4_' + key] = cleanValue.slice(0, 120);
          saveAttributionContext(context);
        });
      } catch (error) {}
    });
  }

  // Attribution is observable only after consent; never invent a pre-consent first visit.
  window.oxxAttributionContext = attributionContext;

  function rfqEvent(name, requestId, params) {
    if (!trackingAllowed()) return;
    if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestId || '')) return;
    var key = requestId && name + ':' + requestId;
    if (key && rfqEventsSeen[key]) return;
    if (key) rfqEventsSeen[key] = true;
    event(name, params);
  }

  function rfqSource(value) {
    var known = ['rfq_page', 'collection-ffkm', 'pdp-quote', 'pdp-application-check', 'pdp-engineer-pro',
      'finder', 'finder-review', 'material-guide', 'size-guide', 'compatibility',
      'application', 'engineering-tool', 'search'];
    var source = String(value || '');
    var publicSources = ["collection-fkm","collection-as568-o-rings","collection-din-iso-metric-o-rings","collection-silicone","collection-epdm","collection-shop-small-packs","drawer","footer","header","home-cta","home-fast-production","home-hero","home-intent","home-lanes","home-supply","home-tools","mobile-menu","nav","nav-materials","nav-side","rail","resources-answers","resources-vacuum","pdp","pdp-documents","pdp-material"];
    return known.indexOf(source) >= 0 || publicSources.indexOf(source) >= 0 ? source : 'other';
  }

  function clean(value) {
    return String(value || '').trim().slice(0, 120);
  }

  function trackingAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(cp && typeof cp.analyticsProcessingAllowed === 'function'
      && cp.analyticsProcessingAllowed() && window['ga-disable-' + MEASUREMENT_ID] !== true);
  }

  function event(name, params) {
    // Shopify's Google & YouTube pixel owns page_view and standard commerce events.
    // Route OXX custom events only to this GA4 measurement ID; do not fan them out to Ads tags.
    if (/^(?:view_item|add_to_cart|begin_checkout)$/.test(String(name))) return;
    if (!trackingAllowed()) { queued.length = 0; return; }
    var eventName = clean(name);
    if (!eventName) return;
    var context = attributionContext();
    var attribution = {};
    if (context) {
      ATTRIBUTION_EVENT_FIELDS.forEach(function (key) {
        if (context[key] !== undefined && context[key] !== null && String(context[key]) !== '') attribution[key] = context[key];
      });
      attribution.attribution_click_id_present = Boolean(context.attribution_click_id_present);
    }
    // Keep GA4 event parameters under the 25-parameter standard-property limit. Full click IDs and detailed UTM fields stay in RFQ/CRM.
    var payload = Object.assign({}, attribution, params || {});
    // QA-only events stay separate from primary conversions and are visible in DebugView.
    if (payload.qa_only === true) payload.debug_mode = true;
    sendGa4Event(eventName, payload);
  }
  window.oxxTrack = event;

  function flushQueuedEvents() {
    if (!ga4Ready || !ga4FrameReady || !trackingAllowed() || typeof ga4FrameGtag !== 'function') return;
    queued.splice(0).forEach(function (item) {
      sendGa4Event(item.name, item.params);
    });
  }

  function refreshGa4Ready() {
    if (!trackingAllowed()) {
      ga4Ready = false;
      if (!ga4FrameLoading && !ga4FrameReady) window.oxxGa4CustomTagStatus = 'CONSENT_REQUIRED';
      return;
    }
    if (!ga4FrameReady || typeof ga4FrameGtag !== 'function') {
      ga4Ready = false;
      ensureGa4Frame();
      return;
    }
    updateGa4FrameConsent();
    ga4Ready = true;
    if (!identifiersEnriched) {
      identifiersEnriched = true;
      enrichGa4Identifiers();
    }
    flushQueuedEvents();
  }

  window.addEventListener('oxxGa4TagReady', refreshGa4Ready);
  window.addEventListener('oxxGa4TagError', function () {
    if (trackingAllowed() && !ga4FrameReady) ensureGa4Frame();
  });

  // The consent-gated tag can become ready before this deferred asset runs.
  // Recheck immediately so custom events do not remain queued after the ready event was missed.
  refreshGa4Ready();

  function pathOnly(href) {
    try { return new URL(href, window.location.origin).pathname; } catch (error) { return ''; }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('[data-oxx-finder-form], form[action*="find-o-rings"]')) {
      event('finder_search', { surface: 'finder', unit: clean(form.querySelector('[name="unit"]')?.value) });
    } else if (form.matches('[data-oxx-rfq], [data-oxx-rfq-form], form[action*="bulk-quote"]')) {
      var idField = form.querySelector('[name="request_id"]');
      var startId = clean(idField && idField.value);
      var startParams = { surface: 'rfq', request_id: startId,
        request_mode: clean(form.querySelector('[name="request_mode"]')?.value) };
      if (/^QA[-_]/i.test(startId)) startParams.qa_only = true;
      rfqEvent('rfq_start', startId, startParams);
    } else if (form.matches('form[action*="/cart/add"]')) {
      event('add_to_cart', { surface: 'product', variant_id: clean(form.querySelector('[name="id"]')?.value) });
    } else if (form.matches('form[action*="/search"]')) {
      event('site_search', { surface: 'search', query_present: Boolean(form.querySelector('[name="q"]')?.value) });
    }
  }, true);

  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target.closest('a,button,summary') : null;
    if (!target) return;
    if (target.matches('summary')) event('help_tooltip_open', { surface: 'disclosure' });
    var href = target.getAttribute('href') || '';
    if (target.matches('[data-oxx-document], a[href*="download"], a[href*=".pdf"]')) {
      event('download_spec', { surface: 'documents', path: pathOnly(href) });
    } else if (href.indexOf('document_request=1') >= 0) {
      event('document_request_start', { surface: 'documents', path: pathOnly(href) });
    } else if (target.matches('[data-oxx-compare], [data-compare]')) {
      event('compare_open', { surface: 'results' });
    } else if (target.matches('[data-oxc-context], [data-oxx-entry]')) {
      event('entry_click', { surface: 'navigation', path: pathOnly(href) });
    } else if (target.matches('a[href*="/checkout"], button[name="checkout"]')) {
      event('begin_checkout', { surface: 'cart' });
    }
  }, true);

  if (document.body && document.body.classList.contains('template-product')) {
    event('view_item', { surface: 'product', product_path: window.location.pathname });
  }

  ['oxx_rfq_submit_attempt', 'oxx_rfq_receiver_accepted', 'oxx_rfq_submit_failed'].forEach(function (eventName) {
    window.addEventListener(eventName, function (e) {
      var detail = e && e.detail ? e.detail : {};
      var requestId = clean(detail.request_id);
      if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestId)) requestId = '';
      var isQaRequest = detail.qa_only === true || /^QA[-_]/i.test(requestId);
      var common = {
        surface: 'rfq',
        request_id: requestId,
        source: rfqSource(detail.source),
        transport: clean(detail.transport || 'ajax_text'),
        request_mode: clean(detail.request_mode),
        outcome: eventName.indexOf('accepted') >= 0 ? 'accepted' : (eventName.indexOf('failed') >= 0 ? 'failed' : 'attempt')
      };
      if (isQaRequest) common.qa_only = true;
      if (eventName === 'oxx_rfq_submit_attempt') {
        var startParams = { surface: 'rfq', request_id: requestId, request_mode: clean(detail.request_mode) };
        if (isQaRequest) startParams.qa_only = true;
        rfqEvent('rfq_start', requestId, startParams);
      }
      rfqEvent(eventName.replace(/^oxx_/, ''), requestId, common);
      // QA receipts validate acceptance without becoming a primary Ads conversion.
      // Service receipt is not a human-qualified business lead.
      // Preserve QA-only assertion; real qualified leads require a verified CRM gate.
      if (eventName === 'oxx_rfq_receiver_accepted' && isQaRequest) {
        var qualifiedEventName = 'qa_qualified_quote_submit';
        var qualifiedParams = {
          surface: 'rfq', request_id: requestId,
          source: rfqSource(detail.source),
          transport: clean(detail.transport || 'ajax_text'),
          request_mode: clean(detail.request_mode), outcome: 'accepted'
        };
        if (isQaRequest) qualifiedParams.qa_only = true;
        rfqEvent(qualifiedEventName, requestId, qualifiedParams);
      }
    });
  });

  // oxx_rfq_clarity_receipt_join_v2: consented and pseudonymous cross-platform RFQ link.
  // Never send raw request IDs, emails, filenames, click IDs or customer details to Clarity.
  // Worker receipt is not a qualified lead or a Google Ads primary conversion.
  (function () {
    var seenClarityActions = Object.create(null);
    var actions = ['oxx_rfq_submit_attempt', 'oxx_rfq_receiver_accepted', 'oxx_rfq_submit_failed'];
    function consented() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
      try { return cp.analyticsProcessingAllowed() === true; } catch (error) { return false; }
    }
    function joinHash(id) {
      if (!window.crypto || !window.crypto.subtle || typeof TextEncoder !== 'function') {
        return Promise.reject(new Error('secure_digest_unavailable'));
      }
      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(id)).then(function (bytes) {
        return Array.prototype.map.call(new Uint8Array(bytes), function (value) {
          return ('0' + value.toString(16)).slice(-2);
        }).join('').slice(0, 24);
      });
    }
    actions.forEach(function (name) {
      window.addEventListener(name, function (e) {
        var detail = e && e.detail ? e.detail : {};
        var id = typeof detail.request_id === 'string' ? detail.request_id : '';
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(id) || /^QA[-_]/i.test(id) || detail.qa_only === true) return;
        if (!consented() || typeof window.clarity !== 'function') return;
        var key = name + ':' + id;
        if (seenClarityActions[key]) return;
        seenClarityActions[key] = true;
        joinHash(id).then(function (hash) {
          if (!consented() || typeof window.clarity !== 'function') return;
          window.clarity('set', 'oxx_rfq_receipt_sha96', hash);
          window.clarity('event', name);
        }).catch(function () { delete seenClarityActions[key]; });
      });
    });
  }());

  document.addEventListener('visitorConsentCollected', function () {
    if (!trackingAllowed()) {
      clearAttributionContext();
      queued.length = 0;
      disposeGa4Frame();
    } else {
      attributionContext();
      refreshGa4Ready();
    }
  });


  // Persist consented first/last-touch attribution to Shopify cart attributes so it can follow an order.
  // Analytics attribution requires analytics consent; click identifiers additionally require marketing consent.
  var attributionCartMarker = 'oxxring:cart-attribution:v2';
  var attributionCartKeys = [
    '__oxx_attr_scope', '__oxx_attr_expires_at',
    '__oxx_first_source', '__oxx_first_medium', '__oxx_first_campaign', '__oxx_first_path', '__oxx_first_referrer', '__oxx_first_at',
    '__oxx_last_source', '__oxx_last_medium', '__oxx_last_campaign', '__oxx_last_path', '__oxx_last_referrer', '__oxx_last_at',
    '__oxx_last_utm_term', '__oxx_last_utm_content', '__oxx_last_utm_id',
    '__oxx_ads_click_id', '__oxx_ads_click_kind', '__oxx_ads_click_seen_utc'
  ];
  var paidClickCartKeys = ['__oxx_ads_click_id', '__oxx_ads_click_kind', '__oxx_ads_click_seen_utc'];
  // Serialize cart writes and coalesce duplicate attribution writes to avoid concurrent cart-token races.
  var cartUpdateQueue = Promise.resolve();
  var cartAttributionWriteInFlight = false;
  var cartAttributionWriteFingerprint = '';
  var cartAttributionWritePending = false;

  function cartText(value, limit) {
    return String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, limit || 240);
  }

  function attributionFingerprint(value) {
    var hash = 2166136261;
    var text = String(value || '');
    for (var i = 0; i < text.length; i++) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16);
  }

  function cartUpdate(attributes) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var write = function () {
      return window.fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).then(function (res) {
        if (!res || !res.ok) throw new Error('ATTRIBUTION_CART_WRITE_FAILED');
        return true;
      });
    };
    var task = cartUpdateQueue.then(write, write);
    cartUpdateQueue = task.then(function () {}, function () {});
    return task;
  }

  function clearCartAttribution(keys) {
    var attributes = {};
    keys.forEach(function (key) { attributes[key] = ''; });
    return cartUpdate(attributes);
  }

  function markPendingCartCleanup(kind) {
    try { window.sessionStorage.setItem(attributionCartMarker, JSON.stringify({ pending_revoke: kind })); } catch (error) {}
  }

  function persistConsentedAttributionToCart(forceRevoke) {
    try {
      var analytics = trackingAllowed();
      var rawMemo = window.sessionStorage.getItem(attributionCartMarker);
      var memo;
      try { memo = JSON.parse(rawMemo || 'null'); } catch (ignore) { memo = null; }
      if (!analytics) {
        if (forceRevoke || (memo && memo.pending_revoke === 'all')) {
          markPendingCartCleanup('all');
          clearCartAttribution(attributionCartKeys).then(function () {
            window.sessionStorage.removeItem(attributionCartMarker);
          }).catch(function () { markPendingCartCleanup('all'); });
        }
        return;
      }

      var context = attributionContext();
      if (!context) return;
      var marketing = marketingAllowed() && navigator.globalPrivacyControl !== true;
      var params = new URLSearchParams(window.location.search || '');
      var clickKind = '', clickId = '';
      if (marketing) {
        CLICK_ID_FIELDS.some(function (key) {
          var raw = queryValue(params, key);
          if (/^[A-Za-z0-9._~-]{8,200}$/.test(String(raw || ''))) {
            clickKind = key; clickId = cartText(raw, 200); return true;
          }
          return false;
        });
        if (!clickKind) {
          var savedClickKind = String(context.last_paid_click_id_type || '');
          var savedClickId = context.last_paid_click_id_value;
          if (CLICK_ID_FIELDS.indexOf(savedClickKind) >= 0 && /^[A-Za-z0-9._~-]{8,200}$/.test(String(savedClickId || ''))) {
            clickKind = savedClickKind;
            clickId = cartText(savedClickId, 200);
          }
        }
      }
      var clickHash = clickId ? attributionFingerprint(clickKind + ':' + clickId) : '';
      var clickSeenAt = clickHash
        ? (memo && memo.click_hash === clickHash && memo.click_seen_utc || context.last_paid_click_at || new Date().toISOString())
        : '';
      var attributes = {
        '__oxx_attr_scope': cartText(context.attribution_scope || 'CONSENTED_FIRST_PARTY_90D', 80),
        '__oxx_attr_expires_at': cartText(context.attribution_expires_at, 40),
        '__oxx_first_source': cartText(context.first_touch_source, 120),
        '__oxx_first_medium': cartText(context.first_touch_medium, 120),
        '__oxx_first_campaign': cartText(context.first_touch_campaign, 200),
        '__oxx_first_path': cartText(context.first_touch_landing_path, 240),
        '__oxx_first_referrer': cartText(context.first_touch_referrer_host, 140),
        '__oxx_first_at': cartText(context.first_touch_at, 40),
        '__oxx_last_source': cartText(context.last_touch_source, 120),
        '__oxx_last_medium': cartText(context.last_touch_medium, 120),
        '__oxx_last_campaign': cartText(context.last_touch_campaign, 200),
        '__oxx_last_path': cartText(context.last_touch_landing_path, 240),
        '__oxx_last_referrer': cartText(context.last_touch_referrer_host, 140),
        '__oxx_last_at': cartText(context.last_touch_at, 40),
        '__oxx_last_utm_term': cartText(context.last_utm_term || context.utm_term, 200),
        '__oxx_last_utm_content': cartText(context.last_utm_content || context.utm_content, 200),
        '__oxx_last_utm_id': cartText(context.last_utm_id || context.utm_id, 200),
        '__oxx_ads_click_id': clickId,
        '__oxx_ads_click_kind': clickKind,
        '__oxx_ads_click_seen_utc': clickSeenAt
      };
      var fingerprint = attributionFingerprint(JSON.stringify(attributes));
      if (cartAttributionWriteInFlight) {
        if (cartAttributionWriteFingerprint !== fingerprint) cartAttributionWritePending = true;
        return;
      }
      if (memo && memo.saved === true && memo.fingerprint === fingerprint) return;

      cartAttributionWriteInFlight = true;
      cartAttributionWriteFingerprint = fingerprint;
      cartUpdate(attributes).then(function () {
        if (!trackingAllowed()) {
          markPendingCartCleanup('all');
          return clearCartAttribution(attributionCartKeys).then(function () {
            window.sessionStorage.removeItem(attributionCartMarker);
          }).catch(function () { markPendingCartCleanup('all'); });
        }
        if (!marketingAllowed() && clickId) {
          markPendingCartCleanup('paid');
          return clearCartAttribution(paidClickCartKeys).then(function () {
            markPendingCartCleanup('paid');
          }).catch(function () { markPendingCartCleanup('paid'); });
        }
        window.sessionStorage.setItem(attributionCartMarker, JSON.stringify({
          saved: true, fingerprint: fingerprint, click_hash: clickHash, click_seen_utc: clickSeenAt
        }));
      }).catch(function () {
        markPendingCartCleanup(!trackingAllowed() ? 'all' : (!marketingAllowed() ? 'paid' : 'retry'));
      }).then(function () {
        var retryPending = cartAttributionWritePending;
        cartAttributionWriteInFlight = false;
        cartAttributionWriteFingerprint = '';
        cartAttributionWritePending = false;
        if (retryPending) persistConsentedAttributionToCart(false);
      });
    } catch (error) {}
  }

  // Shopify's privacy API and the layout's ga-disable flag can settle after this deferred asset runs.
  // Retry briefly only while consent is unresolved/analytics is allowed but the loader has not enabled tracking.
  function retryAttributionAfterPrivacyReady(attempt) {
    if (attempt >= 40) return;
    if (trackingAllowed()) {
      persistConsentedAttributionToCart(false);
      return;
    }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var apiReady = Boolean(cp && typeof cp.analyticsProcessingAllowed === 'function');
    if (apiReady) {
      var analyticsAllowed = false;
      try { analyticsAllowed = cp.analyticsProcessingAllowed(); } catch (error) {}
      if (!analyticsAllowed) return;
    }
    setTimeout(function () {
      retryAttributionAfterPrivacyReady(attempt + 1);
    }, 250);
  }

  // If GA4 becomes ready after the first attribution attempt, retry the cart write.
  window.addEventListener('oxxGa4TagReady', function () {
    persistConsentedAttributionToCart(false);
  });
  document.addEventListener('visitorConsentCollected', function () { persistConsentedAttributionToCart(true); });
  attributionContext();
  refreshGa4Ready();
  persistConsentedAttributionToCart(false);
  if (!trackingAllowed()) retryAttributionAfterPrivacyReady(0);
}());
